module.exports = __webpack_public_path__ + "static/img/weather15.be0bcf5a.png";